const modalMassService = {
  massServiceTipography: 'Serviço em massa',
  autocomplete: 'Serviço',
  date: 'Data do vencimento',
  errorTitle: 'Tipos de equipamento divergentes',
  error: 'Todos os tipos de equipamento devem ser iguais e possuir pelo menos algum serviço de equipamento com serviço em massa ativado nos parâmetros',
  comment: '[BULK] SERVIÇO REALIZADO EM MASSA'
}
  
export default modalMassService;